import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter, map, startWith } from 'rxjs';

@Component({
  selector: 'app-app-header',
  standalone: true,
  templateUrl: './app-header.component.html',
  styleUrl: './app-header.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppHeaderComponent {
  private router = inject(Router);
 
  isHomePage$ = this.router.events.pipe(
    filter((event): event is NavigationEnd => event instanceof NavigationEnd),
    map((event) => this.checkIfHomePage(event.urlAfterRedirects)),
    startWith(this.checkIfHomePage(this.router.url))
  );

  private checkIfHomePage(url: string): boolean {
    return url === '/home' || url === '/' || url === '';
  }

  navigateToPricing(): void {
    this.router.navigate(['/pricing']);
  }

  navigateToAreaDoAssociado(): void {
    window.open('https://associado-dev.gs1pt.org/login', '_blank', 'noopener,noreferrer');
  }

  navigateToAdesao(): void{

   window.open('https://gs1pt.org/adesao/', '_blank', 'noopener,noreferrer');
  } 

 

  

}